package com.milta.feature.subscription.domain.entity

enum class SubscriptionStatus { Active, Trial, Expired, Cancelled }
